export const CONTRACT_FEES_COUNT = 'CONTRACT_FEES_COUNT';
export const CONTRACT_FEES_SAVE = 'CONTRACT_FEES_SAVE';
export const CONTRACT_FEES_GET = 'CONTRACT_FEES_GET';
export const CONTRACT_FEES_GET_ALL = 'CONTRACT_FEES_GET_ALL';
export const CONTRACT_FEES_ADD_UPDATE = 'CONTRACT_FEES_ADD_UPDATE';
export const CONTRACT_FEES_ERROR = 'CONTRACT_FEES_ERROR';
export const CONTRACT_FEES_CLEAR = 'CONTRACT_FEES_CLEAR';
export const CONTRACT_FEES_CLEAR_ALL_UPDATES = 'CONTRACT_FEES_CLEAR_ALL_UPDATES';
export const CONTRACT_FEES_REMOVE_ALL_EDITS = 'CONTRACT_FEES_REMOVE_ALL_EDITS';
